var _path, _path2, _ellipse, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 149,
    viewBox: "0 0 146 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4955 34.5931L21.2396 96.3623C19.2462 99.5657 17.9429 103.328 19.0036 106.94C20.8146 113.107 25.5008 118.065 31.5324 120.301C31.1716 119.491 30.8626 118.653 30.6098 117.792C29.5491 114.18 30.8524 110.418 32.8458 107.214L67.1017 45.445C72.5827 36.6371 83.1623 33.8444 91.8765 37.0669L90.5047 34.5931C82.4788 21.696 63.5213 21.696 55.4955 34.5931Z",
    fill: "current",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 78.4377V51.3374M73 98.5247V98.7629M107.256 121.333H38.7442C29.3858 121.333 21.4883 115.148 19.0035 106.687C17.9428 103.074 19.2461 99.3121 21.2396 96.1087L55.4954 34.3395C63.5212 21.4424 82.4788 21.4424 90.5046 34.3396L124.76 96.1087C126.754 99.3121 128.057 103.074 126.996 106.687C124.512 115.148 116.614 121.333 107.256 121.333Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.1283,
    cy: 144.795,
    rx: 58.7347,
    ry: 4.20473,
    fill: "current",
    stroke: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 98.7369,
    r: 1.62659,
    stroke: "current",
    strokeWidth: 0.5,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.583c00ff24d9d6cbab9deff0e2405bd6.svg";
export { ForwardRef as ReactComponent };